import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var RESOLUTION = 64;
/**
 * Create a burst protection which allows running function only a number of times in a configurable window
 * @param milliseconds - length of the checked window in milliseconds
 * @param max - maximum number of functions to run in that window
 * @param functionName - function name for error message
 */

export default function makeBurstProtection(milliseconds, max) {
  var functionName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "The function";

  if (milliseconds <= 0 || max <= 0) {
    return function (fn) {
      return fn;
    };
  }

  var callCounts = [0];
  var lastErrorOutput = 0;
  var lastIntervalTime = Date.now();

  function updateCallCounts() {
    var now = Date.now();
    var intervalLength = milliseconds / RESOLUTION;

    if (now < lastIntervalTime + intervalLength) {
      return;
    } // Prepend callCounts with correct number of zeroes and keep its length to RESOLUTION at max


    var intervalCountSinceLast = Math.floor((now - lastIntervalTime) / intervalLength);
    callCounts = Array(Math.min(intervalCountSinceLast, RESOLUTION)).fill(0).concat(callCounts).slice(0, RESOLUTION);
    lastIntervalTime += intervalCountSinceLast * intervalLength;
  }

  function getTotalCallCount() {
    return callCounts.reduce(function (total, item) {
      return total + item;
    });
  }

  function incrementCallCount() {
    callCounts[0]++;
  }

  return function (fn) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var now,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              updateCallCounts();

              if (!(getTotalCallCount() < max)) {
                _context.next = 6;
                break;
              }

              incrementCallCount();
              _context.next = 5;
              return fn.apply(void 0, _args);

            case 5:
              return _context.abrupt("return", _context.sent);

            case 6:
              now = Date.now();

              if (lastErrorOutput < now - milliseconds) {
                lastErrorOutput = now;
                console.error("".concat(functionName, " was called more than ").concat(max, " times during last ").concat(milliseconds, "ms. Ignoring."));
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
}